module.exports = fox._r("images/cross.png", __webpack_public_path__ + "_/_/_/common/frame/images/cross.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/cross.png
// module id = 97
// module chunks = 2